import { HttpRequest, HttpHandlerFn, HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export const apiInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn) => {
  if (request.url.startsWith(environment.prefix)) {
    const url = `${environment.apiUrl}${request.url}`;
    const apiRequest = request.clone({
      url: url,
    });
    return next(apiRequest);
  }
  return next(request);
};
